module.exports = __webpack_public_path__ + "media/notice.7cb9a9a5.mp3";